<ng-container *ngIf="{
  row: columnData | async
} as $">
<span *ngIf="$.row && $.row.pymt_status">{{getPaymentStatus( $.row.pymt_status)}} </span>
<span *ngIf="$.row && $.row.pymt_log_derived_status">{{getPaymentDerivedStatus( $.row.pymt_log_derived_status)}} </span>
</ng-container>
